import './BlockedBrowserWarning.scss';

import React from 'react';
import { getChromeDownloadUrl } from '../../utils/browserDetector';
import splash0Image from '../../img/splash0.png';
import { useTranslation } from 'react-i18next';

interface IBlockedBrowserWarningProps {
  browserName: string;
  isMobile: boolean;
}

/**
 * 被禁止的浏览器警告页面
 * 完全阻止用户访问，要求下载Chrome
 */
const BlockedBrowserWarning: React.FC<IBlockedBrowserWarningProps> = ({ isMobile }) => {
  const { t } = useTranslation();
  const chromeDownloadUrl = getChromeDownloadUrl(isMobile);

  return (
    <div className='blocked-browser-container'>
      <div className='blocked-browser-content'>
        <img src={splash0Image} alt='Logo' className='app-logo' />
        <h1 className='warning-title'>
          <span className='warning-icon'>⚠️</span>
          {t('browserWarning.blocked.title')}
        </h1>
        <p className='warning-message'>{t('browserWarning.blocked.message')}</p>

        <a href={chromeDownloadUrl} target='_blank' rel='noopener noreferrer' className='download-button'>
          {isMobile ? t('browserWarning.blocked.downloadButtonMobile') : t('browserWarning.blocked.downloadButton')}
        </a>

        <p className='tip'>
          {isMobile ? t('browserWarning.blocked.tipMobile') : t('browserWarning.blocked.tipDesktop')}
        </p>
      </div>
    </div>
  );
};

export default BlockedBrowserWarning;
